export default __webpack_public_path__ + "static/media/Farmote-Company-Logo.d5fa240c.png";